"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
// Relements
var icon_1 = __importDefault(require("relements/build/esm/ui/icon"));
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
// Icons
var omniPrompt_1 = require("@haptik/helpers/build/esm/omniPrompt");
var SOCIAL_CHANNELS_ICONS = {
    whatsapp: omniPrompt_1.GroupWhatsappIcon,
    messenger: omniPrompt_1.GroupMessengerIcon,
    instagram: omniPrompt_1.GroupInstagramIcon,
};
var StyledIcon = styled_components_1["default"](icon_1["default"])(function (props) { return ({
    width: 32,
    height: 32,
    marginLeft: props.index ? '-8px' : '0px',
    position: 'relative',
    zIndex: props.listLength - props.index,
}); });
var SocialChannelIcons = function (_a) {
    var channels = _a.channels;
    return (react_1["default"].createElement(box_1["default"], { padding: "0px" }, channels.map(function (channel, index) { return (react_1["default"].createElement(StyledIcon, { src: SOCIAL_CHANNELS_ICONS[channel.type], index: index, type: channel.type, listLength: channels.length })); })));
};
exports["default"] = SocialChannelIcons;
